// extracted by mini-css-extract-plugin
module.exports = {"google-button":"GoogleButton_google-button__I8aQt"};